var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"down-box"},[_c('div',{staticClass:"price-num"},[_vm._v(" 价格："),_c('span',[_vm._v(_vm._s(_vm.priceData)+"￥")])]),_c('div',{staticClass:"buy-tip"},[_vm._v("如有需求请联系企业客服")])])
}
var staticRenderFns = []

export { render, staticRenderFns }